import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE } from '@mui/x-data-grid/locales';
import { get, sortBy } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useApplication } from 'src/context/ApplicationContext';
import { KOSTEN_ARTEN, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { DisplayEuroMUI } from 'src/utils/formats';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import kostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
const KP_P = kostenPositionSchema.attributes;

const PersonalkostenUebersichtAntragStipendium: FC<{}> = () => {
	const { application } = useApplication();
	const columns = [
		// { field: 'id', headerName: 'ID', width: 80, groupable: false },
		{ field: 'bezeichnung', headerName: 'Name', flex: 1, groupable: false },
		{ field: 'kostenKategorie', headerName: 'Beschäftigungsart', flex: 1, groupable: false },
		...Array.from({ length: get(application, P.Allgemein_Projektdauerin_Jahren.path) }).map((_, i) => {
			return {
				field: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
				headerName: `${get(application, P.Allgemein_Projektstart_Jahr.path) + i}`,
				flex: 1,
				type: 'number' as const,
				valueFormatter: (value: any) => {
					return value ? DisplayEuroMUI(value) : 0;
				},
			};
		}),
		{
			field: 'gesamtSumme',
			headerName: 'Geplante Gesamtsumme (€)',
			flex: 1,
			type: 'number' as const,
			valueFormatter: (value: any) => {
				return value ? DisplayEuroMUI(value) : 0;
			},
		},
	];

	const rows = useMemo(() => {
		let row = get(application, P.Foerderantrag_Kostenpositions.path, [])
			.filter((ele: any) => get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Personalkosten)
			.map((ele: any) => {
				const kostenProJahr = get(ele, KP_P.Allgemein_Kosten_Pro_Jahr.path, []).reduce((acc: any, proJahr: any) => {
					acc[get(proJahr, 'Zelle_1')] = get(proJahr, 'Zelle_2');
					return acc;
				}, {});
				return {
					id: get(ele, 'id'),
					kostraeger: get(ele, KP_P.Allgemein_Kostentraeger.path, ''),
					unternehmen: get(ele, KP_P.Unternehmen.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path),
					bezeichnung: get(ele, KP_P.Allgemein_Bezeichnung.path),
					kostenart: get(ele, KP_P.Allgemein_Kostenart_Finanzierung.path),
					kostenKategorie: get(ele, KP_P.Allgemein_Kostenkategorie.schema.attributes.Allgemein_Bezeichnung.path),
					...kostenProJahr,
					gesamtSumme: get(ele, KP_P.Allgemein_Geplante_Gesamtsumme.path),
				};
			});
		return sortBy(row, 'bezeichnung');
	}, [application]);

	const initialState: any = useMemo(() => {
		const projectStartYear = get(application, P.Allgemein_Projektstart_Jahr.path);
		const projectDurationYears = get(application, P.Allgemein_Projektdauerin_Jahren.path);

		const model: any = Array.from({ length: projectDurationYears }).reduce((acc: any, _, i) => {
			acc[projectStartYear + i] = 'sum';
			return acc;
		}, {});

		return {
			aggregation: {
				model: {
					...model,
					gesamtSumme: 'sum',
				},
			},
		};
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Personalkosten Übersicht' description={PLATZHALTER_TEXT} />
			<div style={{ height: 600, width: '100%' }}>
				<DataGridPremium
					rows={rows}
					columns={columns}
					initialState={initialState}
					groupingColDef={{ leafField: 'unternehmen' }}
					hideFooter
					localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
				/>
			</div>
		</>
	);
};
export default PersonalkostenUebersichtAntragStipendium;
